import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

const Return: FC<IconV2Props> = ({ className, icon }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn(`svg-icon--${icon}`, className)}
    width="23"
    height="15"
    viewBox="0 0 23 15"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-102.000000, -1066.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g transform="translate(102.709468, 1066.000000)">
          <path d="M4.55725079,7 L3.41836588,7.97618706 L6.90553845e-15,3.98809353 L3.41836588,0 L4.55725079,0.97618706 L2.608,3.25 L16.381441,3.25 C19.5099821,3.25 22.0405319,5.82741176 22.0405319,9 C22.0405319,12.0988071 19.6263135,14.6297985 16.5987167,14.7458431 L16.381441,14.75 L2.29053186,14.75 L2.29053186,13.25 L16.381441,13.25 C18.6753319,13.25 20.5405319,11.3502593 20.5405319,9 C20.5405319,6.72096072 18.7866615,4.8655495 16.5887556,4.75519312 L16.381441,4.75 L2.628,4.75 L4.55725079,7 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Return;
